 
   <div class="landing-page-container">
    <app-landing-header (openPricingPopupEvent)="openPricingPopup()"></app-landing-header>

    <!-- Hero Section -->
    <app-banner-landing></app-banner-landing>

    <!-- Problem Section -->
    <!-- Constat & Solution Section -->
    <app-problem-section></app-problem-section>

    <!-- Solution Section -->
    <app-value-prop></app-value-prop>

    <!-- ROI Section -->
    <app-roi-section (openROIPopupEvent)="openROIPopup()"></app-roi-section>

    <!-- Process Section -->
    <app-process-section></app-process-section>

    <!-- Interactive Preview Section -->
    <app-preview-section></app-preview-section>

    <!-- Academy & Support Section -->
    <app-academy-section></app-academy-section>

    <!-- Testimonials Section -->
    <app-testimonials-section></app-testimonials-section>

    <!-- Final CTA -->
    <app-final-cta   (openDemoPopupEvent)="openDemoPopup()"></app-final-cta>
    <app-pricing-popup  [pricingPopupVisible]="pricingPopupVisible" (closePricingPopupEvent)="closePricingPopup()"></app-pricing-popup>
    <app-noi-popup [roiPopupVisible]="roiPopupVisible" (closeROIPopupEvent)="closeROIPopup()" (openDemoPopupEvent)="openDemoPopup()"></app-noi-popup>
    <app-demo-popup [demoPopupVisible]="demoPopupVisible" (closeDemoPopupEvent)="closeDemoPopup()"></app-demo-popup>
    <!-- Footer -->
    <app-landing-footer></app-landing-footer>
    
  
     
   </div>